<template>
  <div class="workshop-people-select">
    <el-dialog
      title="选择人员"
      :visible.sync="showPanel"
      v-dialogDrag
      width="1050px"
      :modal="false"
      class="dialog"
      @close="close"
    >
      <div class="content" style="height: 530px">
        <el-form :inline="true">
          <el-form-item label="姓名">
            <el-input placeholder="请输入" v-model="filter.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input placeholder="请输入" v-model="filter.phone"></el-input>
          </el-form-item>
          <!-- <el-form-item label="工号">
            <el-input placeholder="请输入" v-model="filter.workNo"></el-input>
          </el-form-item> -->
          <el-form-item label="部门">
            <el-input
              clearable
              placeholder="请选择部门"
              @click.native="showTree = !showTree"
              v-model="departmentNames"
              @clear="handleClear"
            ></el-input>
            <div
              class="tree-container"
              v-show="showTree"
              @mouseleave="showTree = false"
            >
              <el-tree
                :data="departmentData"
                ref="tree"
                node-key="departmentCode"
                :props="treeProps"
                :renderContent="renderContent"
                :filter-node-method="filterNode"
                show-checkbox
                @check="handleCheck"
              >
              </el-tree>
            </div>
          </el-form-item>

          <el-button type="primary" @click="getPersonList">查询</el-button>
          <el-button type="info" @click="reset">重置</el-button>
        </el-form>
        <el-table
          :data="tableData"
          height="400px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" />
          <el-table-column prop="name" label="姓名" />
          <el-table-column prop="workNo" label="工号" />
          <el-table-column prop="departmentName" label="部门" />
          <el-table-column prop="position" label="岗位" />
          <el-table-column prop="phone" label="手机" />
        </el-table>
        <div class="footer">
          <el-pagination
            class="page-comp"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-size="page.pageSize"
            :total="page.total"
            :current-page="page.currentPage"
            @size-change="sizeChange"
            @current-change="pageChange"
            @prev-click="pageChange"
            @next-click="pageChange"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button type="info" @click="close">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../api";
export default {
  components: {},
  props: {
    workGroupCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showPanel: false,
      unselectedList: [],
      // 选中的人员名单
      selectedList: [],
      // 姓名
      name: "",
      treeData: [],
      treeProps: {
        label: "departmentName",
        id: "departmentCode",
        children: "subDepartmentList",
      },
      tableData: [],
      page: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      departmentData: [],
      showTree: false,
      departmentNames: "",
      departmentCodeList: [],
      filter: {
        name: "",
        phone: "",
        workNo: "",
      },
    };
  },

  watch: {
    name(val) {
      this.$refs.tree.filter(val);
    },
    showPanel(val) {
      if (!val) {
        this.clearData();
      }
    },
  },

  methods: {
    // 列表勾选人员
    handleSelectionChange(value) {
      this.selectedList = value;
    },

    // 清除部门信息
    handleClear() {
      this.$refs.tree.setCheckedNodes([]);
      this.departmentCodeList = [];
    },

    // 获取选中部门的code
    handleCheck(data, nodes) {
      this.departmentNames = nodes.checkedNodes
        .map((item) => item.departmentName)
        .join(",");
      this.departmentCodeList = nodes.checkedKeys;
    },

    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.getPersonList();
    },

    pageChange(pageNo) {
      this.page.currentPage = pageNo;
      this.getPersonList();
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },

    // 显示新增工作组人员弹窗
    open({ workShopGroupCode } = {}) {
      this.showPanel = true;
      this.workShopGroupCode = workShopGroupCode;
      this.getPersonList();
      this.getDepartmentTree();
    },
    // 获取人员
    async getPersonList() {
      let params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        departmentCodeList: this.departmentCodeList,
        name: this.filter.name,
        phone: this.filter.phone,
        workNo: this.filter.workNo,
      };
      const {
        success,
        returnObj: { list, total },
        msgContent,
      } = await this.$fetch(api.queryWorkshopPersonnel, params);
      if (success) {
        if (list && list.length) {
          this.tableData = list;
          this.page.total = total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      } else {
        this.$message.error(msgContent);
      }
      // console.log(this.treeData, 'this.treeData')
    },
    // 重置
    reset() {
      this.clearData();
      this.getPersonList();
    },
    clearData() {
      this.filter.name = "";
      this.filter.workNo = "";
      this.filter.phone = "";
      this.page.pageSize = 10;
      this.page.currentPage = 1;
      this.page.total = 0;
      this.departmentNames = "";
      this.departmentCodeList = [];
      this.$refs.tree.setCheckedKeys([]);
    },
    // 获取部门树
    async getDepartmentTree() {
      const { success, returnObj } = await this.$fetch(api.queryDepartmentTree);
      this.departmentData = returnObj;
    },

    // 获取当前在当前不在车间的人员
    async getInList() {
      let params = {
        workShopGroupCode: this.workShopGroupCode,
      };
      const { success, returnObj, msgContent } = await this.$fetch(
        api.queryInWorkShopGroupInfo,
        params
      );
      if (success) {
        if (returnObj && returnObj.length) {
          this.selectedList = returnObj.map((item) => {
            return {
              personnelCode: item.personnelCode,
              name: item.name,
              checked: true,
            };
          });
        }
      } else {
        msgContent && this.$message.error(msgContent);
      }
    },

    // 自定义渲染节点
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node personwidth" title={node.label}>
          <span>{node.label}</span>
        </span>
      );
    },

    // 移动人员
    transferPerson(type) {
      if (type === "left") {
        let selectedPerson = this.$refs.tree.getCheckedNodes();
        if (selectedPerson.length) {
          this.selectedList = this.selectedList.concat(selectedPerson);
          let data = this.selectedList.map((item) => {
            return {
              personnelCode: item.personnelCode,
              name: item.name,
              checked: true,
            };
          });
          this.selectedList = this.reduceArr(data, "personnelCode");

          selectedPerson = selectedPerson.map((item) => {
            return {
              personnelCode: item.personnelCode,
              name: item.name,
              checked: true,
            };
          });

          this.treeData.forEach((item, index) => {
            selectedPerson.forEach((items) => {
              if (items.personnelCode === item.personnelCode) {
                item.checked = items.checked;
              }
            });
          });

          this.treeData = this.treeData.filter((item) => !item.checked);
        } else {
          selectedPerson = [];
        }
      } else if (type === "right") {
        // 移除右边已选人员
        if (this.selectedList.length) {
          let rightChoose = this.selectedList.filter(
            (item) => item.checked === true
          );
          this.selectedList = this.selectedList.filter(
            (item) => item.checked === false
          );
          this.treeData = this.treeData.concat(rightChoose);
        } else {
          this.selectedList = [];
        }
      }
    },

    reduceArr(arr, key) {
      let obj = {};
      let newArr = arr.reduce((cur, next) => {
        obj[next[key]] ? "" : (obj[next[key]] = true && cur.push(next));
        return cur;
      }, []);
      return newArr;
    },

    //保存
    submit() {
      if (this.selectedList.length) {
        let chooseIds = [
          ...new Set(this.selectedList.map((item) => item.personnelCode)),
        ];

        let params = {
          personnelCodeList: chooseIds,
          workShopGroupCode: this.workShopGroupCode,
        };

        this.$fetch(api.addWorkShopGroupInfo, params).then((res) => {
          if (res.success) {
            this.close();
            this.$message.success("添加人员成功");
            this.$emit("refreshData");
          } else {
            this.$message.error(res.msgContent);
          }
        });
      } else {
        this.$message.warning("请选择人员");
      }
    },

    close() {
      this.showPanel = false;
      this.selectedList.length = 0;
      this.account = "";
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.workshop-people-select {
  .content {
    background: #181f2e;
    padding: 16px;
    &-top {
      display: flex;
      justify-content: space-around;
      align-content: space-around;
      text-align: center;
      padding-bottom: 30px;
      &-left,
      &-right {
        width: 48%;
        height: 350px;
        border-width: 1px;
        border-style: solid;
        display: flex;
        flex-direction: column;
        padding: 0 5px;
        h2 {
          background-color: rgba(38, 43, 55, 1);
          margin-bottom: 0;
        }
        .account {
          line-height: 24px;
          padding: 0 10px;
          text-align: left;
        }
        .group-list {
          height: calc(100% - 90px);
          overflow-y: scroll;
        }
        .person-list {
          text-align: left;
          padding: 5px 10px;
          height: calc(100% - 36px);
          overflow-y: scroll;

          .person {
            display: flex;
            align-items: center;
            padding: 5px 0px;
            color: #b9c3d9;
            font-size: 14px;
            .name-icon {
              margin: 0 5px;
            }
            .checked-name {
              display: inline-block;
              max-width: 140px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-left: 5px;
            }
          }
        }
      }
      &-middle {
        .to-left {
          margin: 100px 0px 10px 0px;
          background: transparent;
        }
        .to-right {
          margin-left: 2px;
          background: transparent;
        }
      }
    }
  }
  .dialog {
    .el-dialog__body {
      padding: 30px;
    }
  }
  .footer {
    margin-top: 12px;
    text-align: center;
    // padding: 20px 20px 20px 0;
  }
  .title {
    height: 36px;
    line-height: 36px;
    font-weight: normal;
  }
  .tree-list .personwidth {
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #b9c3d9;
  }
  // .tree-list .el-tree .is-current > .el-tree-node__content,
  // .tree-list .el-tree-node__content:hover {
  //   background-color: transparent;
  // }
  .person-list .el-checkbox__input.is-checked + .el-checkbox__label {
    // color: #c9d5ec;
  }
  .expand {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 2px;
    border: 1px solid #b3cbf1;
  }
  .tree-container {
    // border: ;
    @include set_theme_color(background-color, input-disabled-bg-color);
    @include set_theme_color(border-color, active-border-color);
    border: 1px solid;
    border-radius: 3px;
    position: absolute;
    top: 40px;
    width: 260px;
    max-height: 300px;
    overflow-y: scroll;
    z-index: 10;
    // @include set_theme_color(background-color, page-tab-item-bg-color);
  }
  .page-comp {
    /* margin: 10px 0; */
    width: 100%;
    margin-top: 5px;
  }
}
</style>
